// extracted by mini-css-extract-plugin
export default {"container":"LinkedinAuthButton_container__Q9xn9"};